import { useLinked } from '@type-r/react';
import { relationshipIdentifierTypes, RelationshipModel } from 'api';
import { CollapsableSection, Column, Columns, CompactTabs, Tab, TilesList, TopSection } from 'lqx-react';
import * as React from 'react';
import { AddIdentifier, IdentifiersRow, removeIdentifier } from '../../../../../common';

export const EditIdentifiers = ({ relationship}: { relationship: RelationshipModel }) => {
    const $identifierType = useLinked<string>( 'relationship' );

    return (
        <TopSection title="Identifiers">
            <CollapsableSection title="Identifiers"
                right={
                    <CompactTabs $value={$identifierType} >
                        <Tab value="relationship">Relationship</Tab>
                        { relationship.ShowCustomer && <Tab value="customer">Customer</Tab> }
                        { relationship.ShowSupplier && <Tab value="supplier">Supplier</Tab> }
                    </CompactTabs>}
            >
                <>
                    {$identifierType.value === 'relationship' ?
                        <>

                            <TilesList
                                items={relationship.identifiers.models}
                                itemSize={66}
                                height={400}
                                renderer={IdentifiersRow(false, removeIdentifier(relationship.identifiers))}
                            />
                            <AddIdentifier identifiers={relationship.identifiers} identifierTypes = {relationshipIdentifierTypes}/>
                        </>
                        : <></>}
                </>
                <>
                    {$identifierType.value === 'customer' ?
                        <>

                            <TilesList
                                items={relationship.Customer.identifiers.models}
                                itemSize={66}
                                height={400}
                                renderer={IdentifiersRow(false, removeIdentifier(relationship.Customer.identifiers))}
                            />
                        </>
                        : <></>}
                </>
                <>
                    {$identifierType.value === 'supplier' ?
                        <>

                            <TilesList
                                items={relationship.Supplier.identifiers.models}
                                itemSize={66}
                                height={400}
                                renderer={IdentifiersRow(false, removeIdentifier(relationship.Supplier.identifiers))}
                            />
                        </>
                        : <></>}
                </>

            </CollapsableSection>
            <CollapsableSection title="Identifiers - Raw view" notExpanded={true}>
                <Columns>
                    <Column>
                        <pre>
                            Relationship:
                            { JSON.stringify(relationship.identifiers, null, 2) }
                            </pre>
                            </Column>
                            {
                                relationship.ShowCustomer &&
                                <Column>
                                <pre>
                                    Customer: { JSON.stringify(relationship.Customer.identifiers, null, 2) }
                                </pre>
                                </Column>
                            }
                            {
                                relationship.ShowSupplier &&
                                <Column>
                                    <pre>
                                        Supplier: { JSON.stringify(relationship.Supplier.identifiers, null, 2) }
                                    </pre>
                                </Column>
                            }
                        </Columns>
            </CollapsableSection>
        </TopSection>
    );
};

